export default __webpack_public_path__ + "static/media/icon_facility_atm.ea217832.svg";